import restApiDispatcher from "@/store/utils/api-dispatcher";
import { ClubEvent, ClubEventList } from "@/models";

const getClubEvents = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEvent,
    storeKey: "clubEvents",
    loadingKey: "clubEventsLoading",
    action: "indexWithProfileId",
    commitType: "index",
    metaKey: "meta",
    params
  });

  const getClubEventsLimitedV1 = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEvent,
    storeKey: "clubEventsLimitedV1",
    loadingKey: "clubEventsLoading",
    action: "indexV2",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getClubEventsLimited = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEvent,
    storeKey: "clubEventsLimited",
    loadingKey: "clubEventsLoading",
    action: "indexV2",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getClubEventsV2 = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEvent,
    storeKey: "clubEvents",
    loadingKey: "clubEventsLoading",
    action: "indexV2",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getClubEvent = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEvent,
    storeKey: "clubEvent",
    loadingKey: "clubEventLoading",
    action: "show",
    commitType: "wrappedShow2",
    params
  });

const getClubEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEventList,
    action: "index",
    loadingKey: "clubEventsLoading",
    storeKey: "clubListEvents",
    commitType: "index",
    metaKey: "meta",
    params
  });

const createClubEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEventList,
    storeKey: "clubListEvents",
    loadingKey: "clubEventsLoading",
    action: "create",
    commitType: "addToList",
    message: "Event successfully created.",
    params
  });

const updateClubEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEventList,
    storeKey: "clubListEvents",
    loadingKey: "clubEventsLoading",
    action: "update",
    commitType: "edit",
    message: "Event successfully updated.",
    params
  });

const deleteClubEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEventList,
    storeKey: "clubListEvent",
    loadingKey: "clubEventsLoading",
    action: "delete",
    message: "Event successfully deleted.",
    params
  });

const updateImageForEvent = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubEventList,
    storeKey: "clubListEvents",
    loadingKey: "clubEventsLoading",
    action: "imageUpdate",
    commitType: "editImage",
    params
  });

const setFavourite = (context, clubEventId) =>
  context.commit("SET_FAVOURITE", clubEventId);

const unsetFavourite = (context, clubEventId) =>
  context.commit("UNSET_FAVOURITE", clubEventId);

export default {
  getClubEvent,
  getClubEvents,
  getClubEventsList,
  createClubEventsList,
  updateClubEventsList,
  deleteClubEventsList,
  updateImageForEvent,
  setFavourite,
  unsetFavourite,
  getClubEventsLimited,
  getClubEventsLimitedV1,
  getClubEventsV2
};
